import styles from './create-profile-review-page.module.css';
import { useTranslation } from '@/contexts/i18n-context';
import { useMediaQuery } from '@/hooks/use-media-query';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';
import { Section } from '@/components/containers/section';
import { NavButton } from '@/components/navigation/nav-button';
import { formatDate } from '@/util/formats';
import { PreferredTitle } from '@/api/api.schemas';
import { PageContainer } from '@/components/containers/page-container';
import { FormButtonRow } from '@/components/containers/form-button-row';
import { SectionHeader } from '@/components/section-header';
import { Button } from '@/components/button';
import { useProfileCreation } from '@/contexts/profile-creation-context';

export function CreateProfileReviewPage() {
  const { t } = useTranslation();
  const { patient } = useProfileCreation();

  const isMobile = useMediaQuery('--screen-md');

  if (!patient) {
    return null;
  }

  const previousStep = patient.surrogate ? '/profile/surrogate' : '/profile/patient-info';

  return (
    <PageContainer>
      {!isMobile && <NavButton to={previousStep} />}
      <GradientFormTitle>
        {isMobile && <NavButton to={previousStep} />}
        <h1 className="h3">{t('patientProfileReview.pageTitle')}</h1>
      </GradientFormTitle>

      <Section>
        <SectionHeader
          title={t('patientProfileReview.patient.title')}
          className={styles.sectionHeader}
          editButton={
            <Button variant="link" leftIcon="edit" as="a" to="/profile/patient-info">
              {t('common.edit')}
            </Button>
          }
        />
        <dl className={styles.sectionContent}>
          <dt>{t('patientProfileReview.patient.name')}</dt>
          <dd>
            {patient.firstName} {patient.lastName}
          </dd>
          <dt>{t('patientProfileReview.patient.preferredTitle')}</dt>
          <dd>
            {patient.preferredTitle !== PreferredTitle.none
              ? t(`preferredTitle.${patient.preferredTitle}`)
              : '-'}
          </dd>
          <dt>{t('patientProfileReview.patient.birthday')}</dt>
          <dd>{formatDate(patient.dateOfBirth)}</dd>
        </dl>

        {patient.surrogate && (
          <>
            <SectionHeader
              title={t('patientProfileReview.surrogate.title')}
              className={styles.sectionHeader}
              editButton={
                <Button variant="link" leftIcon="edit" as="a" to="/profile/surrogate">
                  {t('common.edit')}
                </Button>
              }
            />
            <dl className={styles.sectionContent}>
              <dt>{t('patientProfileReview.surrogate.name')}</dt>
              <dd>
                {patient.surrogate.firstName} {patient.surrogate.lastName}
              </dd>
              <dt>{t('patientProfileReview.surrogate.preferredTitle')}</dt>
              <dd>
                {patient.surrogate.preferredTitle !== PreferredTitle.none
                  ? t(`preferredTitle.${patient.surrogate.preferredTitle}`)
                  : '-'}
              </dd>
              <dt>{t('patientProfileReview.surrogate.birthday')}</dt>
              <dd>{formatDate(patient.surrogate.birthday)}</dd>
            </dl>
          </>
        )}
      </Section>

      <FormButtonRow buttonTextKey="patientProfileReview.confirmBtn" as="a" to="/" />
    </PageContainer>
  );
}
